// @flow
import EventListElementMatch from 'components/event/EventListElementMatch';
import { connect } from 'react-redux';
import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/event/EventListElementMatch';

const mapDispatchToProps =  (state: StateType): StateProps => ({
  competitionsEquipes: state.settingsState.competitionsEquipes,
});

export default connect(mapDispatchToProps)(EventListElementMatch);
